const getExtras = (inningsData = {}) => {
  const { byes, legbyes, wides, noballs, extras } = inningsData;
  return { breakdown: `b: ${byes} lb: ${legbyes} wd: ${wides} nb: ${noballs}`, total: extras };
};

export default getExtras;
